const packagesDesignEditor = {
}

const packagesContentEditor = {
  customTemplate: `<div class="custom-package" :class="package.css_classes + package.auto_tags.join(' ')">
  <template v-if="package.current_event_credit_quantity-package.event_credit_quantity==1">
      <div class="orelha-bonus">
          <span>+1 aula bônus</span>
      </div>
  </template>
  <template v-else-if="package.current_event_credit_quantity-package.event_credit_quantity>1">
      <div class="orelha-bonus">
          <span>+{{package.current_event_credit_quantity-package.event_credit_quantity}} aulas bônus</span>
      </div>
  </template>

  <div class="custom-package-content">
      <div class="d-flex align-items-center">
          <Truncate class="custom-package-title" :value="package.name" />
          <template v-if="package.description">
              <i class="ml-1 text-dark fas fa-question-circle custom-package-tooltip">
                  <div class="top">
                      <span v-html="package.description"></span>
                      <i></i>
                  </div>
              </i>
          </template>
      </div>
      <template v-if="!hasRecurrency">
          <template v-if="priceDividedPerCredit > currentPriceDividedPerCredit || package.event_credit_quantity > package.current_event_credit_quantity">
              <div class="custom-package-base-price-row desconto">
                  <span class="desconto_top">
                      <template v-if="!isUnlimited">
                          preço/aula
                      </template>
                      <template v-else>
                          valor total
                      </template>
                       
                  </span> 
              </div>
          </template>
          <template v-else>
              <template v-if="!isUnlimited">
                  <div class="custom-package-price-info-top">preço/aula</div>
              </template>
              <template v-else>
                  <div class="custom-package-price-info-top">valor total</div>
              </template>
          </template>
      
          <div class="custom-package-price-per-credit">
              <!-- <span class="custom-package-price-per-credit-currency">{{ currencySymbol }}</span> -->
              <template v-if="!isUnlimited">
                  <span class="custom-package-price-per-credit-value">{{ $n(currentPriceDividedPerCredit, 'currency').split(',')[0] }}</span>
              </template>
              <template v-else>
                  <span class="custom-package-price-per-credit-value">{{ $n(package.current_price, 'currency').split(',')[0] }}</span>
              </template>
          </div>
          <div class="custom-package-divider"></div>
          <template v-if="!isUnlimited">
              <div class="custom-package-price-info-bottom">valor total</div>
          </template>
          <div class="custom-package-all-credits-amount">
              <template v-if="isUnlimited">
                  <span class="plano-ilimitado">Plano Ilimitado</span>
              </template>
              <template v-else>
                  <template
                      v-if="package.current_price < package.price_sales_base">
                      {{ package.current_event_credit_quantity }}
                      {{ package.current_event_credit_quantity > 1 ? 'aulas' : 'aula' }} <span
                          class="custom-package-line-through">de: {{ $n(package.price_sales_base, 'currency') }}</span>
                      por: 
                      {{ $n(package.current_price, 'currency') }}
                  </template>
                  <template v-else>
                      {{ package.current_event_credit_quantity }}
                      {{ package.current_event_credit_quantity > 1 ? 'aulas' : 'aula' }} por:
                      {{ $n(package.current_price, 'currency') }}
                  </template>
              </template>
          </div>
      </template>
      <template v-else>
          <template v-if="package.recurrency_trial_days > 0">
              <div class="degustacao">
                  <p>
                      {{ package.recurrency_trial_days }} dias grátis
                  </p>
              </div>
              <div class="custom-package-divider"></div>
              <div class="custom-package-price-info-bottom min-height-to-align-when-recurrency fim-degustacao">
                  <span>
                      {{ $n(package.price_sales_base, 'currency') }}/mês após {{ package.recurrency_trial_days }} dias
                  </span>
              </div>
          </template>
          <template v-else>
              <template v-if="priceDividedPerCredit > currentPriceDividedPerCredit || package.event_credit_quantity > package.current_event_credit_quantity">
                  <div class="custom-package-base-price-row recorrente_desconto">
                      <span class="desconto_top">
                          valor total de: <s>{{ $n(package.price_sales_base, 'currency') }}/mês</s> por:
                      </span> 
                  </div>
              </template>
              <template v-else>
                  <div class="custom-package-price-info-top">valor total</div>
              </template>
              <div class="custom-package-recurrency-price">
                  <!-- <span class="custom-package-recurrency-price-currency">{{ currencySymbol }}</span> -->
                  <span class="custom-package-recurrency-price-value">
                      {{ $n(package.current_price, 'currency').split(',')[0] }}
                  </span>
                  <span class="custom-package-recurrency-price-unit">/mês</span>
              </div>
              <!-- <div class="custom-package-price-info-bottom">valor mensal</div> -->
              <div class="custom-package-divider"></div>
              <template v-if="package.name=='Single Club'">
                <ul>
                  <li>Treine quantas vezes quizer</li>
                  <li>ACESSO ANTECIPADO AOS AGENDAMENTOS</li>
                  <li>Espaço Voipi</li>
                  <li>Plataforma AT HOME</li>
                </ul>
              </template>
              <div class="custom-package-price-info-bottom min-height-to-align-when-recurrency">
                      <span class="plano-ilimitado">Plano Ilimitado</span>
                  <!--<template v-if="isUnlimited">
                      <span class="uso-ilimitado">Uso Ilimitado</span>
                  </template>-->
              </div>
          </template>
      </template>
      <template v-if="(package.recurrency_trial_days > 0) && hasRecurrency">
          <div class="fundo-botao-degustacao">
              <div class="centraliza_botao">
                  <button class="btn btn-primary btn-lg custom-package-action-btn" @click="addToCheckout">COMPRAR</button>
              </div>
              <div class="custom-package-validity">
                  <template v-if="hasRecurrency"> <span>&nbsp;</span> 
                      <template v-if="package.recurrency_trial_days > 0">
                          <span>Pacote com renovação mensal iniciando após o término do período gratuito.</span>
                      </template>
                      <template v-else>
                          <span>Pacote com renovação mensal.</span>
                      </template>
                  </template>
                  <template v-else>
                      <span>Créditos expiram em {{ package.current_event_credit_validity }} dias.</span>
                  </template>
              </div>
          </div>
      </template>
      <template v-else>
          <div class="fundo-botao">
              <button class="btn btn-primary btn-lg custom-package-action-btn" @click="addToCheckout">COMPRAR</button>
              <div class="custom-package-validity">
                  <template v-if="hasRecurrency"> <span>&nbsp;</span> 
                      <template v-if="package.recurrency_trial_days > 0">
                          <span>Pacote com renovação mensal iniciando após o término da degustação.</span>
                      </template>
                      <template v-else>
                          <span>Pacote com renovação mensal.</span>
                      </template>
                  </template>
                  <template v-else>
                      <span>Créditos expiram em {{ package.current_event_credit_validity }} dias.</span>
                  </template>
              </div>
          </div>
      </template>
  </div>
</div>`,
  useCustomTemplate: false,
  separationMode: '', // '' section button
  categorySlugList: [],
  showFloatingCart: 'always', // never always,
  useAddToCartButton: false,
  useBuyButton: true,
  // showUnlimitedExplanation: false,
  // addToCartButtonText: '',
  // removeFromCartButtonText: '',
  // buyButtonText: '',
  useDefaultGridCols: true,
  usePOSAsFilter: false,
  packageParams: JSON.stringify({
    teste: 1
  }),
  show_in_carroussel_mobile: false,
  show_in_carroussel_desktop: false,
  //titleWidget:'Pacotes', 
  //use_location_unit_selector: true,
  
  location_unit_selector_params: JSON.stringify({
      "activity_list": "3"
  }),
  bonusStripColor: 'red',
  showinstallmentsLabel: true,
  showIconsWithInformation:true,
  use_multi_widgets: true,
  multi_widgets_params: JSON.stringify([{"recurrency_enabled":"true", "title": "Recorrentes"}, {"recurrency_enabled":"false", "title": "Pacotes"}]),
  paramsFilterRequestPOS:JSON.stringify({"tag":"grom"})
  // disableGetPackagesOnRender: true
}

export {
  packagesDesignEditor,
  packagesContentEditor,
}